import { LeadStatus } from '@bariendo/lib/active-lead';
import { ORBIT_DISABLED, ORBIT_GRAY, ORBIT_NEEDS_ACTION, ORBIT_SETTLED } from '@/theme/colors';

export interface LeadStatusOption {
  status: LeadStatus;
  label: string;
  /** Under the label in the menu. */
  hint: string;
  dotColor: string;
  textColor: string;
}

// Lost is grey, never red: a lost lead is a normal outcome, not an error.
export const LEAD_STATUS_OPTIONS: LeadStatusOption[] = [
  { status: 'active', label: 'Active', hint: 'Working this lead now', dotColor: ORBIT_SETTLED, textColor: 'black' },
  {
    status: 'hold',
    label: 'Hold',
    hint: 'Revisit later, not now',
    dotColor: ORBIT_NEEDS_ACTION,
    textColor: ORBIT_NEEDS_ACTION,
  },
  { status: 'lost', label: 'Lost', hint: 'Closed out', dotColor: ORBIT_DISABLED, textColor: ORBIT_GRAY },
];

export const LEAD_STATUS_OPTION = Object.fromEntries(
  LEAD_STATUS_OPTIONS.map((option) => [option.status, option])
) as Record<LeadStatus, LeadStatusOption>;
